var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogContentHistory__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("היסטוריית שינויים - " + _vm._s(_vm.fieldLabel)),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogContentHistory__Component__Loading" },
          [
            _c("b-loading", {
              attrs: { "is-full-page": false, "can-cancel": false },
              model: {
                value: _vm.isLoading,
                callback: function ($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading",
              },
            }),
            !_vm.isLoading && _vm.history.length === 0
              ? _c("div", { staticClass: "no-history" }, [
                  _c("p", [_vm._v("אין היסטוריית שינויים עבור שדה זה")]),
                ])
              : _vm._e(),
            !_vm.isLoading && _vm.history.length > 0
              ? _c(
                  "div",
                  { staticClass: "history-list" },
                  _vm._l(_vm.history, function (item) {
                    return _c(
                      "div",
                      { key: item.id, staticClass: "history-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "history-header" },
                          [
                            _c("div", { staticClass: "history-meta" }, [
                              _c("span", { staticClass: "history-date" }, [
                                _vm._v(
                                  _vm._s(_vm.formatDate(item.changedDate))
                                ),
                              ]),
                              item.changedByUserName
                                ? _c("span", { staticClass: "history-user" }, [
                                    _vm._v(
                                      " " + _vm._s(item.changedByUserName) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  size: "is-small",
                                  type: "is-primary",
                                  loading: _vm.restoringId === item.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreVersion(item)
                                  },
                                },
                              },
                              [_vm._v(" שחזר גרסה זו ")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "history-content" },
                          [
                            _c("div", {
                              staticClass: "content-preview",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getPreview(item.fieldValue)
                                ),
                              },
                            }),
                            _c(
                              "b-button",
                              {
                                attrs: { size: "is-small", type: "is-text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand(item.id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.expandedId === item.id
                                        ? "הצג פחות"
                                        : "הצג יותר"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.expandedId === item.id
                              ? _c("div", {
                                  staticClass: "content-full",
                                  domProps: {
                                    innerHTML: _vm._s(item.fieldValue),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: { label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }